import { ReactElement } from 'react';
import { Redirect, Switch } from 'react-router';
import { Route } from 'react-router-dom';
import { Auth } from './__legacy__/routes/config/Auth';
import { Home } from './__legacy__/routes/config/Home';
import { HomeRoute } from './__legacy__/routes/home.route';
import { ConfirmEmailView } from './__legacy__/views/auth/ConfirmEmail.view';
import { ConfirmNewEmailView } from './__legacy__/views/auth/ConfirmNewEmail.view';
import { ForgotPasswordView } from './__legacy__/views/auth/ForgotPassword.view';
import { LoginView } from './__legacy__/views/auth/Login.view';
import { RegisterView } from './__legacy__/views/auth/Register.view';
import { ResendConfirmationEmailView } from './__legacy__/views/auth/ResendConfirmationEmail.view';
import { ResetPasswordView } from './__legacy__/views/auth/ResetPassword.view';
import { RequireAuth } from './RequireAuth';

export const AppRoutes = (): ReactElement => (
  <Switch>
    <Route
      exact
      path={Auth.Login.Path}
    >
      <LoginView />
    </Route>
    <Route
      exact
      path={Auth.ConfirmEmail.Path}
    >
      <ConfirmEmailView />
    </Route>
    <Route
      exact
      path={Auth.Register.Path}
    >
      <RegisterView />
    </Route>
    <Route
      exact
      path={Auth.ConfirmNewEmail.Path}
    >
      <ConfirmNewEmailView />
    </Route>
    <Route
      exact
      path={Auth.ResendConfirmationEmail.Path}
    >
      <ResendConfirmationEmailView />
    </Route>
    <Route
      exact
      path={Auth.ForgotPassword.Path}
    >
      <ForgotPasswordView />
    </Route>
    <Route
      exact
      path={Auth.ResetPassword.Path}
    >
      <ResetPasswordView />
    </Route>
    <Route path={Home.Path}>
      <RequireAuth>
        <HomeRoute />
      </RequireAuth>
    </Route>
    <Route>
      <Redirect
        exact
        from='/'
        to={Auth.Login.Path}
      />
    </Route>
  </Switch>
);
